<template> 
    <div v-if="showPopup" class="background-popup" @click.self="closePopup()">
        <div class="popup-content">
            <v-row style="padding-bottom: 15px;">
                <div v-if="company_id_to_edit !==null">
                    <p class="title">{{$t("PopupCreateCompany.edit_company")}}</p>
                </div>
                <div v-else>
                    <p class="title">{{$t("PopupCreateCompany.create_companies")}}</p>
                </div>
            </v-row>
            <v-row>
                <v-text-field
                    v-model="company_name"
                    :label="$t('PopupCreateCompany.company_name')"
                    outlined
                />
            </v-row>
            <v-row>
                <v-text-field
                    v-model="cif"
                    :label="$t('PopupCreateCompany.company_cif')"
                    outlined
                />
            </v-row>
            <v-row style="padding-top: 15px; justify-content: right;">
                <v-btn @click="closePopup()" outlined color="primary" style="margin-right: 20px;">
                    {{$t("PopupCreateCompany.cancel")}}
                </v-btn>
                <v-btn @click="saveCompany()" color="primary">
                    <div v-if="company_id_to_edit !==null">{{$t("PopupCreateCompany.edit")}}</div>
                    <div v-else>{{$t("PopupCreateCompany.create")}}</div>
                </v-btn>
            </v-row>
        </div>
    </div>
</template>

<script>
import { sync_command_dispatcher } from "@/api/client";

export default {
    name: "PopupCreateCompany",
    props: {
        showPopup: {
            type: Boolean,
            required: false,
            default: false,
        },
        company_id_to_edit: {
            type: Number,
            required: false,
            default: false,
        }
    },
    data() {
        return {
            company_name: "",
            cif: "",
        };
    },
    methods: {
        async saveCompany(){
            console.log("Creando empresa...")
            try {
                await sync_command_dispatcher.dispatch("save.simple.company", {
                    company_id: this.company_id_to_edit,
                    cif: this.cif,
                    name: this.company_name,
                })
                console.log("Empresa creada!")
                this.closePopup()
            } catch(error) {
                console.error("Error al crear empresa: ",error)
            }
        },
        closePopup(){
            this.$emit("closePopup", false)
        }
    }
};
</script>

<style scoped>
    .title {
        font-size: 20;
        color: #639;
        font-weight: 600;
    }
    .background-popup {
        position:fixed !important;
        top: 0 !important;
        left: 0 !important;
        width: 100% !important;
        height: 100% !important;
        background-color: rgba(0, 0, 0, 0.5) !important;
        display: flex !important;
        justify-content: center !important;
        align-items: center !important;
        z-index: 9998 !important;
    }

    .popup-content {
        background-color: white !important;
        padding: 30px 50px !important;
        border-radius: 8px !important;
        width: 600px !important;
        z-index: 9999 !important;
    }
</style>